var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.surveydata
    ? _c("div", [
        _c("div", { staticClass: "container" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                !_vm.isPhone
                  ? _c("h3", {
                      domProps: {
                        innerHTML: _vm._s(_vm.surveydata.misc.surveyHeader)
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.matchingSurveys, function(srv, idx) {
                  return _c(
                    "div",
                    { key: "srv" + idx, staticClass: "card text-left" },
                    _vm._l(srv.surveyOptions, function(srvOpt, idx) {
                      return _c("div", { key: "srvOpt" + idx }, [
                        _c("h4", {
                          staticClass: "srvopt-question",
                          domProps: { innerHTML: _vm._s(srvOpt.question) }
                        }),
                        _vm._v(" "),
                        _vm.hasProp(srvOpt, "question")
                          ? _c("span", {
                              staticClass: "badge badge-primary",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.surveydata.misc.questionBadge
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasProp(srvOpt, "question") ? _c("hr") : _vm._e(),
                        _vm._v(" "),
                        _c("span", {
                          domProps: { innerHTML: _vm._s(srvOpt.questionLabel) }
                        }),
                        _vm._v(" "),
                        !_vm.hasProp(srvOpt, "question") &&
                        srv.surveyId !== "132813328"
                          ? _c("div", { staticClass: "form-check" }, [
                              _c("input", {
                                staticClass: "form-check-input",
                                attrs: {
                                  type: "radio",
                                  name: srv.surveyId,
                                  id: srv.surveyId + idx
                                },
                                on: {
                                  input: function($event) {
                                    _vm.addReplaceAnswersRadio({
                                      id: srv.surveyId,
                                      l: srvOpt.label,
                                      a: parseInt(srvOpt.value)
                                    })
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("label", {
                                staticClass: "form-check-label",
                                attrs: { for: srv.surveyId + idx },
                                domProps: { innerHTML: _vm._s(srvOpt.label) }
                              })
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.hasProp(srvOpt, "question") &&
                        srv.surveyId === "132813328"
                          ? _c("div", { staticClass: "form-check" }, [
                              _c("input", {
                                staticClass: "form-check-input",
                                attrs: {
                                  type: "checkbox",
                                  name: srv.surveyId,
                                  id: srv.surveyId + idx
                                },
                                on: {
                                  input: function($event) {
                                    _vm.addReplaceAnswersCheckbox(
                                      {
                                        id: srv.surveyId,
                                        l: srvOpt.label,
                                        a: parseInt(srvOpt.value)
                                      },
                                      $event
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("label", {
                                staticClass: "form-check-label",
                                attrs: { for: srv.surveyId + idx },
                                domProps: { innerHTML: _vm._s(srvOpt.label) }
                              })
                            ])
                          : _vm._e()
                      ])
                    }),
                    0
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _vm.matchingSurveys.length > 0 &&
                _vm.matchingSurveys.some(function(ms) {
                  return ms["surveyId"] !== "132813328"
                })
                  ? _c("button", {
                      staticClass:
                        "btn btn-consent btn-primary btn-lg btn-block",
                      attrs: {
                        "data-toggle": "modal",
                        "data-target": "#preview",
                        disabled:
                          _vm.answers.length !== _vm.matchingSurveys.length
                      },
                      domProps: {
                        innerHTML: _vm._s(_vm.surveydata.misc.previewAnswersBtn)
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.matchingSurveys.length === 1 &&
                _vm.matchingSurveys[0].surveyId === "132813328"
                  ? _c("button", {
                      staticClass:
                        "btn btn-consent btn-primary btn-lg btn-block",
                      attrs: {
                        "data-toggle": "modal",
                        "data-target": "#preview",
                        disabled: _vm.answers.length !== 0
                      },
                      domProps: {
                        innerHTML: _vm._s(_vm.surveydata.misc.previewAnswersBtn)
                      }
                    })
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm" })
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "modal fade",
            attrs: { id: "preview", role: "dialog", tabindex: "-1" }
          },
          [
            _c("div", { staticClass: "modal-dialog" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    _c("h4", {
                      domProps: {
                        innerHTML: _vm._s(_vm.surveydata.misc.previewAnswersBtn)
                      }
                    }),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: { type: "button", "data-dismiss": "modal" }
                      },
                      [_vm._v("×")]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.answers, function(answ, idx) {
                      return _c(
                        "div",
                        { key: "answ" + idx, staticClass: "text-left" },
                        [
                          _c("strong", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.surveydata.misc.questionBadge
                              )
                            }
                          }),
                          _vm._v(
                            ": " +
                              _vm._s(_vm.getMatchingSurveyQuestion(answ.id)) +
                              "\n            "
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c("strong", {
                            domProps: {
                              innerHTML: _vm._s(_vm.surveydata.misc.answerBadge)
                            }
                          }),
                          _vm._v(": " + _vm._s(answ.l) + "\n            "),
                          _c("div", { staticClass: "clearfix" })
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-block",
                        on: { click: _vm.confirmAnswers }
                      },
                      [_vm._v("Bekräfta svar")]
                    )
                  ],
                  2
                )
              ])
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-6" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7859deec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7859deec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Survey.vue
// module id = null
// module chunks = 